import { AfterViewInit, Component, ElementRef, HostBinding, Injector, ViewChild } from '@angular/core';
import { MenuAsideOffcanvasDirective } from 'src/assets/lib/metronic/app/core/directives/menu-aside-offcanvas.directive';
import { LayoutRefService } from 'src/assets/lib/metronic/app/core/services/layout-ref.service';
import { appModuleAnimation } from 'src/shared/animations/routerTransition';
import { AppConsts } from 'src/shared/AppConsts';
import { AppComponentBase } from 'src/shared/common/app-component-base';

@Component({
  standalone: false,
  templateUrl: './theme3-layout.component.html',
  selector: 'theme3-layout',
  animations: [appModuleAnimation()],
})
export class Theme3LayoutComponent extends AppComponentBase implements AfterViewInit {
  @ViewChild('mHeader', { static: true }) mHeader: ElementRef;
  @ViewChild('mAsideLeft', { static: true }) mAsideLeft: ElementRef;
  @HostBinding('attr.mMenuAsideOffcanvas') mMenuAsideOffcanvas: MenuAsideOffcanvasDirective;

  remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
  defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/eaf/eaf-' + this.currentTheme.baseSettings.menu.asideSkin + '.png';

  constructor(
    injector: Injector,
    private layoutRefService: LayoutRefService,
  ) {
    super(injector);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mMenuAsideOffcanvas = new MenuAsideOffcanvasDirective(this.mAsideLeft);
      this.mMenuAsideOffcanvas.ngAfterViewInit();
    });

    this.layoutRefService.addElement('header', this.mHeader.nativeElement);
  }
}
